export default "__VITE_ASSET__DQWu9uTh__"